import React, { useState } from "react";
import { DatePicker, Modal } from "antd";
import dayjs from "dayjs";
import "./date-modal.css";

export default function DateModal({ open, onClose, onSubmit, initialValue = "" }) {
  // initialValue should be an ISO string or empty
  const [value, setValue] = useState(initialValue ? dayjs(initialValue) : null);

  const handleSubmit = () => {
    if (value) {
      onSubmit(value.toISOString());
      onClose();
    }
  };

  return (
    <Modal
      title={
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontWeight: 700, fontSize: 26, marginBottom: 8 }}>
            When to start the classes
          </div>
          <div style={{ fontWeight: 400, fontSize: 18, color: '#222' }}>
            Select Date and time
          </div>
        </div>
      }
      open={open}
      onCancel={onClose}
      footer={[
        <div key="footer" className="modal-button-container">
          <button
            key="cancel"
            onClick={onClose}
            className="cancel-button"
          >
            Cancel
          </button>
          <button
            key="submit"
            onClick={handleSubmit}
            disabled={!value}
            className="submit-button-date"
          >
            Submit
          </button>
        </div>
      ]}
      width={520}
      centered
      destroyOnClose
      maskClosable={true}
      style={{ top: 20 }}
    >
      <div style={{ 
        width: '100%', 
        marginBottom: 32, 
        position: 'relative', 
        display: 'flex', 
        justifyContent: 'center',
        padding: '20px 0'
      }}>
        <DatePicker
          value={value}
          onChange={setValue}
          format="DD MMM YYYY"
          placeholder="05 Oct 2023"
          style={{
            width: '100%',
            padding: '8px 16px',
            fontSize: 16,
            border: '1.5px solid #B7B7B7',
            borderRadius: 6,
            background: '#F8F8F8',
            color: '#222',
            boxSizing: 'border-box',
          }}
          allowClear={false}
          inputReadOnly
        />
      </div>
    </Modal>
  );
} 